/**
 * Utility for extracting entity link references from Tiptap JSON content.
 */

export interface ExtractedEntityLink {
  entityId: string
  entityType: string // 'work_item' | 'document' | 'project'
  label: string
}

/**
 * Extract entity links from Tiptap JSON content.
 * Traverses the document tree to find entityLink nodes.
 */
export function extractEntityLinksFromContent(
  tiptapJson: string,
): Array<ExtractedEntityLink> {
  try {
    const doc = JSON.parse(tiptapJson)
    const links: Array<ExtractedEntityLink> = []
    const seen = new Set<string>()

    function traverseNodes(node: any) {
      if (!node) return

      if (node.type === 'entityLink' && node.attrs?.id) {
        const key = `${node.attrs.id}:${node.attrs.entityType}`
        if (!seen.has(key)) {
          seen.add(key)
          links.push({
            entityId: node.attrs.id,
            entityType: node.attrs.entityType || '',
            label: node.attrs.label || '',
          })
        }
      }

      if (Array.isArray(node.content)) {
        node.content.forEach(traverseNodes)
      }
    }

    traverseNodes(doc)
    return links
  } catch {
    return []
  }
}
